import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "antd/lib/date-picker/style/css";
import _DatePicker from "antd/lib/date-picker";
import * as tslib_1 from "tslib";
import * as React from "react";
import { Field } from "formik";
import moment from "moment";
var $MonthPicker = _DatePicker.MonthPicker,
    $RangePicker = _DatePicker.RangePicker,
    $WeekPicker = _DatePicker.WeekPicker;
export var DatePicker = function DatePicker(_a) {
  var name = _a.name,
      validate = _a.validate,
      restProps = tslib_1.__rest(_a, ["name", "validate"]);

  return React.createElement(Field, {
    name: name,
    validate: validate
  }, function (_ref) {
    var value = _ref.field.value,
        _ref$form = _ref.form,
        setFieldValue = _ref$form.setFieldValue,
        setFieldTouched = _ref$form.setFieldTouched;
    return React.createElement(_DatePicker, Object.assign({
      value: value ? moment(value) : undefined,
      onChange: function onChange(date) {
        setFieldValue(name, date ? date.toISOString() : null);
        setFieldTouched(name, true);
      }
    }, restProps));
  });
};

DatePicker.MonthPicker = function (_a) {
  var name = _a.name,
      validate = _a.validate,
      restProps = tslib_1.__rest(_a, ["name", "validate"]);

  return React.createElement(Field, {
    name: name,
    validate: validate
  }, function (_ref2) {
    var value = _ref2.field.value,
        _ref2$form = _ref2.form,
        setFieldValue = _ref2$form.setFieldValue,
        setFieldTouched = _ref2$form.setFieldTouched;
    return React.createElement($MonthPicker, Object.assign({
      value: value ? moment(value) : undefined,
      onChange: function onChange(date) {
        setFieldValue(name, date ? date.toISOString() : null);
        setFieldTouched(name, true);
      }
    }, restProps));
  });
};

DatePicker.RangePicker = function (_a) {
  var name = _a.name,
      validate = _a.validate,
      restProps = tslib_1.__rest(_a, ["name", "validate"]);

  return React.createElement(Field, {
    name: name,
    validate: validate
  }, function (_ref3) {
    var value = _ref3.field.value,
        _ref3$form = _ref3.form,
        setFieldValue = _ref3$form.setFieldValue,
        setFieldTouched = _ref3$form.setFieldTouched;
    return React.createElement($RangePicker, Object.assign({
      name: name,
      value: value,
      onChange: function onChange(value) {
        setFieldValue(name, value);
        setFieldTouched(name, true);
      }
    }, restProps));
  });
};

DatePicker.WeekPicker = function (_a) {
  var name = _a.name,
      validate = _a.validate,
      restProps = tslib_1.__rest(_a, ["name", "validate"]);

  return React.createElement(Field, {
    name: name,
    validate: validate
  }, function (_ref4) {
    var value = _ref4.field.value,
        _ref4$form = _ref4.form,
        setFieldValue = _ref4$form.setFieldValue,
        setFieldTouched = _ref4$form.setFieldTouched;
    return React.createElement($WeekPicker, Object.assign({
      name: name,
      value: value,
      onChange: function onChange(value) {
        setFieldValue(name, value);
        setFieldTouched(name, true);
      }
    }, restProps));
  });
};